<template>
  <div class="login" v-if="global._PROJECT!='shdq'">
    <h1 class="logo">注册</h1>
    <div class="content">
      <div class="form">
        <!--<div class="input-item">-->
          <!--<span class="phone-header">+86</span>-->
          <!--<input type="text" class="phone" v-model="phone" placeholder="请输入手机号">-->
          <!--<span class="code-info" @click="getCode">{{codeInfo}}</span>-->
        <!--</div>-->
        <!--<div class="input-item">-->
          <!--<input type="text" v-model="code" placeholder="请输入验证码">-->
        <!--</div>-->
        <!--<div class="input-item">-->
          <!--<input type="password" v-model="password" placeholder="请输入密码">-->
        <!--</div>-->
        <div class="input-item">
          <input type="text" v-model="username" placeholder="请输入用户名">
        </div>
        <div class="input-item">
          <input type="password" v-model="password" placeholder="请输入密码">
        </div>
        <div class="second">
          <span class="forget" @click="login">前往登录</span>
        </div>
        <div class="sub-btn" @click="register">注 册</div>
      </div>
      <div class="cut"></div>
      <div class="right">
        <div class="des">
          <span>已有账号？</span>
          <span class="register" @click="login">立即登录</span>
        </div>
        <!--<div class="other">-->
          <!--使用其他方式登录-->
          <!--<div>-->
            <!--<i class="fa fa-qq"></i>-->
            <!--<i class="fa fa-weixin"></i>-->
          <!--</div>-->
        <!--</div>-->
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    data() {
      return {
        username:'',
        phone: '',
        code: '',
        password: '',
        codeInfo: '获取验证码',
        count: 60
      }
    },
    methods: {
      getCode(){
        const self = this;
        if (this.codeInfo != '获取验证码') return;
        else if (!this.isTel(self.phone)) {
          this.$message.error('手机号格式有误');
          return;
        } else {
          this.codeInfo = '发送中...';
          this.$http({
            method: 'post',
            url: self.global.api.analyze + '/apps/'+self.$route.query.app+'/iapi/misc/smscode/',
            data: self.qs.stringify({mobile: self.phone}),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
          }).then(response => {
            if (response.data == '验证码已发送到手机,请查收!') {
              self.$message.success('验证码已发送到手机');
              self.countDown();
            }
          }, error => {
            self.$message.error('手机号已注册');
            self.codeInfo = '获取验证码';
          });
        }
      },
      isTel(phone){
        if (!(/^1[34578]\d{9}$/.test(phone))) {
          return false;
        } else {
          return true;
        }
      },
      countDown(){
        const self = this;
        this.codeInfo = this.count + '秒后可重发';
        const time = setInterval(function () {
          if (self.count > 0 && self.codeInfo != '获取验证码') {
            self.codeInfo = self.count + '秒后可重发';
            self.count--;
          } else {
            clearInterval(time);
            self.codeInfo = '获取验证码';
            self.count = 60;
          }
        }, 1000);
      },
      register() {
//        const self = this;
//        console.log(this.$route);
//        if(!this.password){
//            self.$message.error('请输入密码');
//            return;
//        }
//        this.$http({
//          method: 'GET',
//          url: self.global.api.analyze + '/iapi/misc/smscode/validation/' + self.phone + '/' + self.code + '/',
//        }).then(function (response) {
//          if (response.data != 'OK') {
//            self.$message.error('验证码有误');
//            return;
//          } else {
//            //注册
//            self.$http({
//              method: 'post',
//              url: self.global.api.analyze + '/iapi/user/register/',
//              data: self.qs.stringify({
//                username: self.phone,
//                password1: self.password,
//                password2: self.password,
//                agreement: true
//              }),
//              headers: {
//                'Content-Type': 'application/x-www-form-urlencoded',
//              }
//            }).then(response1 => {
//              self.$http({
//                method: 'post',
//                url: self.global.api.analyze + '/iapi/user/login/',
//                data: self.qs.stringify({'username': self.phone, 'password': self.password}),
//                headers: {
//                  'Content-Type': 'application/x-www-form-urlencoded',
//                }
//              }).then(function (response2) {
//                if (self.$route.query.next)
//                  window.location = self.$route.query.next
//              }, error => {
//                self.$message.error('请输入正确的用户名密码')
//              })
//            }, error => {
//              self.$message.error(JSON.stringify(error.data));
//            })
//          }
//        }, error => {
//          self.$message.error('验证码有误');
//        });
        const self = this;
        if(!this.password){
            self.$message.error('请输入密码');
            return;
        }
        if(!self.$route.query.app&&!(this.username=='volvo'||this.username=='luoxb'||this.username=='13701171932')){
          self.$message.error('账号不可用');
          return;
        }
        this.$http({
          method: 'post',
          url: (self.$route.query.app?('/apps/'+self.$route.query.app):'')+'/iapi/user/register/',
          data: self.qs.stringify({
            username: self.username,
            password: self.password,
          }),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        }).then(response1 => {
          if(response1.data.code!=0){
            self.$message.error(response1.data.message);
            return;
          }
          self.$http({
            method: 'post',
            url: (self.$route.query.app?('/apps/'+self.$route.query.app):'')+'/iapi/user/login/',
            data: self.qs.stringify({'username': self.username, 'password': self.password}),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            }
          }).then(function (response2) {
            if (self.$route.query.next)
              window.location = self.$route.query.next
          }, error => {
            self.$message.error('请输入正确的用户名密码')
          })
        }, error => {
          self.$message.error(JSON.stringify(error.data));
        })

      },
      login(){
          const self = this;
        this.$router.push({name:'Login',query:self.$route.query});
      }
    }
  }
</script>

<style scoped>
  .login {
    position: absolute;
    width: 700px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-top: -50px;
  }

  .logo {
    text-align: left;
    margin-bottom: 20px;
    margin-left: 10px;
    font-size: 44px;
    color: #fff;
  }

  .content {
    border: 1px solid #dce1e6;
    border-radius: 2px;
    background: #fff;
    padding: 80px 60px;
    text-align: left;
  }

  .form {
    width: 300px;
    display: inline-block;
  }

  .input-item {
    width: 100%;
    margin-bottom: 10px;
    position: relative;
  }

  .input-item input {
    border: 0;
    border-bottom: 1px solid #ededed;
    width: 100%;
    height: 44px;
    box-shadow: none;
    font-size: 14px;
    padding-left: 10px;
    color: #333;
    outline: none;
  }

  .phone-header {
    position: absolute;
    height: 44px;
    line-height: 44px;
    left: 10px;
  }

  .input-item .phone {
    padding-left: 50px;
  }

  .code-info {
    position: absolute;
    height: 44px;
    line-height: 44px;
    right: 0;
    color: #00b38a;
    top: 0;
    font-size: 12px;
    cursor: pointer;
  }

  .second {
    text-align: right;
    font-size: 14px;
    color: #00b38a;
    margin: 20px 0;
  }

  .forget {
    cursor: pointer;
  }

  .sub-btn {
    line-height: 45px;
    height: 45px;
    text-align: center;
    color: #fff;
    background: #00b38a;
    cursor: pointer;
  }

  .cut {
    width: 1px;
    background: #ededed;
    height: 200px;
    display: inline-block;
    margin: 0 30px;
    position: relative;
    color: #ededed;
  }

  .cut:after {
    position: absolute;
    content: 'or';
    left: 50%;
    top: 50%;
    padding: 2px;
    transform: translate(-50%, -50%);
    background: #fff;
  }

  .right {
    float: right;
    width: 200px;
    font-size: 14px;
    height: 230px;
    position: relative;
    text-align: center;
  }

  .register {
    color: #00b38a;
    cursor: pointer;
  }

  .des {
    margin-top: 100px;
    margin-bottom: 20px;
  }

  .other {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
  }

  .other i {
    margin-right: 10px;
    cursor: pointer;
  }

  @media screen and (max-width: 414px) {
    .login {
      width: 100%;
      top: 0;
      left: 0;
      bottom: 0;
      transform: translate(0, 0);
      margin-top: 0;
    }

    .logo {
      margin-top: 10px;
      margin-bottom: 10px;
      font-size: 32px;
    }

    .content {
      border: 0;
      text-align: center;
      padding: 80px 0;
    }

    .cut {
      display: none;
    }

    .right {
      float: none;
      width: 100%;
      height: 200px;
    }

    .des {
      margin-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pass/Register.vue